<template>
<div v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
    <div class="d-flex h-100 w-100">
        <div class="col-md-3">
          <searchAnnouncements  v-on:SearchDados="GetFilter"></searchAnnouncements>
        </div>

        <div class="col-md-9">
          <div>
              <tableAnnouncements ref="tableAnnouncementsComponent" :key="tablereload" :comunicadoInfo="comunicadoInfo" v-on:openAddModal="openAddModal"></tableAnnouncements>
              <div class="container-modal">
                <addAnnouncements ref="add-comunicado" v-on:updateTable="updateTable" :comunicadoInfo="comunicadoInfo" :titleModal="'Adicionar novo Comunicado'"></addAnnouncements>
              </div>
          </div>
        </div>
    </div>
</div>

</template>

<script>
import Announcements from '@/views/private/realestate/announcements/announcements.js'
export default Announcements
</script>

<style scoped>
#form-seacch{
  display: flex;
  flex-direction: column;
  align-content: center;
}

.periodos{
 display: flex;
 flex-wrap: wrap;
 justify-content: space-around;
}

.arrow-angel{
  padding-top: 10px;
  font-size: 30px;
  color: black;
  padding-right: 24px;
}

.acording{
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  background-color: #ECEFF1;
  border-radius: 0px;
  height: 50px;
  width: 100%;
}
.mes{
  font-size: 22px;
  color: black;
  padding-top: 16px;
  font-weight: bold;
}

.footer{
  margin-bottom: 10%;
}

.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

.btn-periodos-active{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

#card-sales{
  height: 100%;
  width: 100%;
  padding: 15px;
  border: 1px solid rgb(180, 180, 180);
  background-color: white;
}
#img-card-sales{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#img-card{
  height: 300px;
  width: 300px;
  object-fit: contain;
}

.btnAdicionarComunicado{
  background-color: #008148;
  bottom: 56px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  font-size: 26px;
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/announcements/announcements.vue